
  import {
    Vue,
    Component,
    Watch
  } from 'vue-property-decorator';
  
	import {
		UserModule
	} from "@/store/modules/user"
  import store from '@/store'

  @Component({
    name: 'app-main'
  })
  export default class AppMain extends Vue {
    @Watch('$route')
    private totop () {
      this.$nextTick(()=>{
        let dom = document.getElementsByClassName('router-container')
        dom[0].scrollIntoView({
          block:'start',
          behavior:'smooth'
        })
      })
    }
  }
